import { motion, useReducedMotion } from 'framer-motion';

export function Reveal({ children, delay = 0, y = 40, className = '', once = true, ...rest }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = '', lineClassName = '', delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="headline-mask">
          <motion.span
            className={`headline-line ${lineClassName}`}
            initial={{ y: '110%' }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Kicker({ children, className = '' }) {
  return (
    <p className={`kicker flex items-center gap-3 ${className}`}>
      <span className="inline-block h-px w-8 brand-bg" />
      {children}
    </p>
  );
}
